import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_460: DocMigration = {
  maxSchemaVersion: "0.0.460",
  description: "Sets option name property with default value if undefined",
  apply(json: any) {
    // Get option sets
    const { optionSets = {} } = json;

    for (const optionSetId of Object.keys(optionSets)) {
      const optionSet = optionSets[optionSetId];

      const options = Object.values(optionSet.options).sort((a: any, b: any) => a.sortIndex - b.sortIndex);
      const optionsWithUndefinedNames = options.filter((o: any) => o.name === undefined);
      for (const option of optionsWithUndefinedNames) {
        optionSets[optionSetId].options[(option as any).id] = {
          ...(option as any),
          name: `Option ${optionsWithUndefinedNames.indexOf(option) + 1}`,
        };
      }
    }

    json.optionSets = optionSets;
    return json;
  },
};
export default migration_0_0_460;
